import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingSkipProductionFactor } from "../../balancingSelectors/selectBalancingConstants";
import { selectResourceInfo } from "../../balancingSelectors/selectBalancingResources";
import { selectProductionResourceBuffAmount } from "../../selectors/selectBuffsInfo";
import { selectRecipeInfo } from "../../selectors/selectRecipeInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { getRecipeIcon } from "../generic/icon/getRecipeIcon";
import { actionProductionSkip } from "../info/production/actionProductionInfo";
import { ContextMenuRunningProcess } from "./ContextMenuRunningProcess";
var mapState = function (state) {
    var selectedBuilding = state.playerBase.buildings.building;
    if (selectedBuilding == undefined || selectedBuilding.production == undefined) {
        return {
            getProcessRemainingTime: function () { return 0; },
            getProcessTotalTime: function () { return 0; },
            renderTimer: function () { return React.createElement(React.Fragment, null); },
            skipProcessFactor: 0,
        };
    }
    var recipe = selectedBuilding.production.recipe;
    var iconResource = recipe ? selectResourceInfo(recipe.product[0].resourceId) : undefined;
    var mainIcon = iconResource ? getRecipeIcon(iconResource) : "";
    var mainLoca = iconResource ? iconResource.locaKey : IdLoca.empty;
    var rawAmount = recipe && recipe.product && recipe.product[0] ? recipe.product[0].amount : undefined;
    var production = selectedBuilding.production.production;
    var remainingTime = production ? production.remainingTime : 0;
    var recipeAmount = production && production.amount ? production.amount : undefined;
    // will not show remaining type if either the amount from the recipe or the amount of produced recipes
    // are undefined.
    var totalAmount = rawAmount && recipeAmount ? rawAmount * recipeAmount : undefined;
    var buffAmount = Long.ZERO;
    if (production != undefined && totalAmount != undefined) {
        var foundRecipe = selectRecipeInfo(state, production.recipeId);
        var productExists = foundRecipe != undefined && foundRecipe.product[0] != undefined;
        if (productExists) {
            buffAmount = Long.fromValue(selectProductionResourceBuffAmount(state, foundRecipe.product[0].id, Long.fromValue(totalAmount)));
        }
    }
    return {
        baseAmount: totalAmount,
        buffAmount: buffAmount,
        getProcessRemainingTime: function (building) {
            return remainingTime;
        },
        getProcessTotalTime: function (building) {
            return building.production
                ? building.production.recipe.productionTime * (recipeAmount || 1)
                : undefined;
        },
        icon: mainIcon,
        skipProcessFactor: selectBalancingSkipProductionFactor(),
        tooltipLoca: mainLoca,
    };
};
var mapDispatch = function (dispatch) { return ({
    onSkip: function (building) { return dispatch(actionProductionSkip(building)); },
}); };
export var ContextMenuRunningProductionDOM = connect(mapState, mapDispatch)(ContextMenuRunningProcess);



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuRunningProductionDOM.tsx
// module id = 2249
// module chunks = 3